<script>
  import * as authService from '../../services/authService'

  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'app-header',
    data () {
      return {
        isSubmitted: false,
        showChangePasswordModal: false,
        changePassword: {
          current_password: '',
          password: '',
          password_confirmation: ''
        }
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      shortName: function () {
        if (this.currentUser && this.currentUser.pessoa) {
          let name = this.currentUser.pessoa.nome.split(' ')
          let firstName = name[0].toLowerCase()
          firstName = firstName.substring(0, 1).toUpperCase() + firstName.substring(1)
          return firstName
        }
        return ''
      },
      userInitials: function () {
        if (this.currentUser && this.currentUser.pessoa) {
          let name = this.currentUser.pessoa.nome.split(' ')
          let firstName = name[0].toLowerCase()
          let lastName = name[name.length - 1].toLowerCase()
          return firstName.substring(0, 1).toUpperCase() + lastName.substring(0, 1).toUpperCase()
        }
        return ''
      }
    },
    methods: {
      ...mapActions(['toggleSidebar']),
      handleDropDownCommand (command) {
        if (command === 'logout') {
          this.onLogout()
        }
      },
      onLogout () {
        authService.logout()
          .then(() => {
            this.$router.push({name: 'registration.home'})
          })
          .catch(e => {
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <header class="header-bar">
        <div class="toggle-menu" @click="toggleSidebar">
            <i class="fa fa-bars"></i>
        </div>
        <router-link :to="{name: 'home'}" class="logo">
            <figure>
                <figcaption>EVENTOS</figcaption>
                <img src="https://urcamp.edu.br/site/img/logos/logo-branco.png" alt="">
            </figure>
        </router-link>
        <div class="header-data">
            <div class="navegation">
                <nav class="menu-icons">
                    <div class="user-info">
                        <div><span class="name">{{shortName}}</span></div>
                        <div><strong>{{currentUser.ref_pessoa}}</strong></div>
                    </div>
                    <el-dropdown @command="handleDropDownCommand">
                        <div class="item-icon user"
                             key="headerAvatarSigla"
                             :title="currentUser.name">
                            {{userInitials}}
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="logout">
                                <i class="fa fa-sign-out"></i>
                                <span>Sair</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </nav>
            </div>
        </div>
        <div v-if="false">
            <div class="app-bar">
                <div class="app-bar-content">
                    <div class="app-bar-logo">
                        <a href="">
                            <strong>URCAMP - Eventos</strong>
                            <span>UE</span>
                        </a>
                    </div>
                    <div class="app-bar-user">

                    </div>
                </div>
            </div>
        </div>
    </header>

</template>

<style lang="scss">
    .header-bar {
        width: 100vw;
        height: 80px;
        background: rgba(51, 68, 61, 1);
        background: -moz-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
        background: -webkit-gradient(left top, right top, color-stop(0%, rgba(51, 68, 61, 1)), color-stop(100%, rgba(59, 80, 71, 1)));
        background: -webkit-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
        background: -o-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
        background: -ms-linear-gradient(left, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
        background: linear-gradient(to right, rgba(51, 68, 61, 1) 0%, rgba(59, 80, 71, 1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#33443d', endColorstr='#3b5047', GradientType=1);
        border-bottom: 5px solid #909E48;
        -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1200;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .toggle-menu {
            display: none;
            width: 50px;
            height: 55px;
            text-align: center;
            color: #FFF;
            line-height: 55px;
            font-size: 24px;
            background-color: rgb(75, 104, 93);
        }

        .header-data {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            flex: 1;
        }

        > .logo {
            margin: 0;
            display: block;
            width: 200px;
            padding: 10px;
            text-decoration: none;
            background-color: #384f45;
            height: 75px;

            figure {
                display: block;
                margin: 0;
                padding: 0;
            }

            figcaption {
                text-align: center;
                color: #FFF;
                font-size: 18px;
                font-weight: 300;
                position: relative;
                right: -5px;
                top: 5px;
            }

            img {
                position: relative;
                top: -10px;
                left: -5px;
                display: block;
                margin: 0 auto;
                max-width: 100%;
                max-height: 44px;
            }
        }

        .header-data {

            > .navegation {
                padding-right: 30px;
            }

            .header-data-title {
                color: #eeeeee;
                font-weight: 300;
                font-size: 38px;
            }

            > .navegation,
            > .notifications {

                .menu-icons {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    height: 75px;

                    .v-menu {
                        display: inline-flex;
                        vertical-align: center;

                        .v-menu__activator.v-menu__activator--active {
                            .item-icon {
                                background-color: rgb(42, 61, 52);
                            }
                        }
                    }
                    .item-icon {
                        width: 65px;
                        height: 75px;
                        line-height: 75px;
                        text-align: center;
                        color: #909E48;
                        font-size: 28px;
                        position: relative;

                        .badge-notify {
                            display: block;
                            position: absolute;
                            right: 5px;
                            bottom: 10px;
                            background-color: #e80000;
                            width: 18px;
                            height: 18px;
                            line-height: 18px;
                            color: #FFF;
                            font-size: 11px;
                            font-weight: bold;
                            text-align: center;
                            border-radius: 50%;
                        }

                        &.user {
                            background-color: rgba(0, 0, 0, 0.2);
                            color: #FFF;
                            text-decoration: none;
                            font-size: 20px;
                            font-weight: bold;
                            border-radius: 50%;
                            width: 55px;
                            height: 55px;
                            line-height: 57px;
                            margin-right: 0;
                            cursor: pointer;
                        }
                    }
                }

                .user-info {
                    font-size: 16px;
                    padding-right: 12px;
                    color: rgba(255, 255, 255, 0.7);
                    text-align: center;
                    line-height: 18px;

                    .name {
                        color: #FFF;
                    }
                    strong {
                        color: #bed160;
                        font-weight: 600;
                        font-size: 14px;
                    }
                }

                .user-avatar {
                    width: 55px;
                    height: 55px;
                    border-radius: 50%;
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    border: 2px solid #4b6a5d;
                    cursor: pointer;
                }
            }
        }
    }

    @media all and (max-width: 1024px) {
        .header-bar {
            .header-data-title {
                display: none;
            }
            .toggle-menu {
                height: 75px;
                line-height: 75px;
                display: block;
            }
            .logo {
                width: 170px;
            }
        }
    }

    @media all and (max-width: 768px) {
        .header-bar {
            height: 60px;
            .toggle-menu {
                height: 55px;
                line-height: 55px;
                display: block;
            }
            > .logo {
                width: 120px;
                height: 55px;
                padding: 5px;
                figcaption {
                    font-size: 14px;
                }
                img {
                    max-width: 94%;
                }
            }

            .header-data {

                .notifications {
                    .menu-icons .item-icon {
                        width: 42px;
                        height: 45px;
                        line-height: 45px;
                        margin-left: 3px;
                        font-size: 24px;
                        .badge-notify {
                            right: 0;
                            bottom: 0;
                        }
                    }
                }
                .navegation {
                    padding-right: 10px;
                    .user-info {
                        display: none;
                    }
                    .user-avatar {
                        width: 40px;
                        height: 40px;
                    }
                    .menu-icons .item-icon.user {
                        width: 40px;
                        height: 40px;
                        line-height: 40px;
                        font-size: 17px;
                    }
                }
            }
        }
    }

    @media all and (max-width: 540px) {
        .header-bar {
            > .navegation {
                .menu-icons a {
                    margin-left: 1px;
                }
            }
        }
    }
</style>
